import { render, staticRenderFns } from "./EditarMetodoPagoPedidoModal.vue?vue&type=template&id=52fe3083"
import script from "./EditarMetodoPagoPedidoModal.vue?vue&type=script&lang=js"
export * from "./EditarMetodoPagoPedidoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports